import { render } from "./originCreate.vue?vue&type=template&id=3ff05bed&scoped=true"
import script from "./originCreate.vue?vue&type=script&lang=js"
export * from "./originCreate.vue?vue&type=script&lang=js"

import "./originCreate.vue?vue&type=style&index=0&id=3ff05bed&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff05bed"]])

export default __exports__